var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-vimeo-player',{directives:[{name:"cursor",rawName:"v-cursor.hidden",value:(_vm.hasControls),expression:"hasControls",modifiers:{"hidden":true}}],staticClass:"o-vimeo",class:{ 'has-controls': _vm.controls },attrs:{"video-id":_vm.id,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }